import { Fetch } from '../utils'

export class BannerApi {
  fetchInstance: Fetch | null

  constructor(bullseyeEndpoint: string) {
    // Override headers without MD-Session-Token to avoid CORS error in bullseye
    this.fetchInstance = new Fetch(bullseyeEndpoint, '', {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    })
  }

  getBanner = async (userGuid: string) => {
    try {
      const path = `/banner/${userGuid}/account_widget_banner`
      return this.fetchInstance?.get(path).then((data) => data.banner) ?? {}
    } catch (error) {
      console.error('Error fetching banner:', error)
      return null
    }
  }
}
